"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimationTicker = void 0;
const app_1 = require("@kennethgomez/app");
const ticker_abstract_1 = require("../ticker.abstract");
class AnimationTicker extends ticker_abstract_1.AbstractTicker {
    update(delta) {
        for (const animation of app_1.App.instance.canvas.animations.get().values()) {
            const { object, property, duration, values, algorithm, } = animation.data;
            const fn = algorithm(animation.progress / duration);
            const progressValue = (values.target - values.initial) * fn;
            const propertyValue = progressValue + values.initial;
            object[property] = propertyValue;
            animation.update(propertyValue);
            animation.updateProgress();
        }
    }
}
exports.AnimationTicker = AnimationTicker;
